import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { StorageKeys } from '../app.constants';
import { ProfileInfo } from '../entities/profile-info.model';
import { LoggingService } from '../shared/logging.service';
import { AbstractReadService } from './abstract.read.service';
import { OfflineNotificationService } from './offline-notification.service';
import { ServerUrl } from './server-url.service';
import { StorageService } from './storage.service';
import { UserEventWriteService } from './user-event.write.service';

@Injectable({ providedIn: 'root' })
export class ProfileService extends AbstractReadService<ProfileInfo> {
  private readonly prefix: string = '/management/info';

  constructor(
    http: HttpClient,
    private readonly storageService: StorageService,
    offlineService: OfflineNotificationService,
    userEventWriteService: UserEventWriteService,
    private readonly serverUrl: ServerUrl,
    log: LoggingService
  ) {
    super(http, storageService, offlineService, userEventWriteService, log);
  }

  public hydrate(obj: any): ProfileInfo {
    const prochain = ProfileInfo.hydrate(obj);
    // TODO: fix photo manquante enregistrement failed
    return prochain;
  }

  public getStorageKey(): string {
    return StorageKeys.PROFILE_INFO;
  }

  public getResourceURL(param: any = null): string {
    return this.serverUrl.get() ? (this.serverUrl.get() as string).replace(/\/mobile$/, '') + this.prefix : '';
  }

  public async fetchCache(): Promise<ProfileInfo> {
    const value = await this.storageService.get(this.getStorageKey());
    return value ? this.hydrateFromString(value) : firstValueFrom(this.fetch().pipe(map(this.hydrate)));
  }

  public async clear(): Promise<void> {
    return this.removeLocally();
  }
}
